module.exports = __webpack_public_path__ + "static/media/member_none.1bf3a0c0.png";